export default __webpack_public_path__ + "img/test-women.923caeb6.png";